import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcClockFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25m0 4a.75.75 0 0 0-.75.75v4.586c0 .464.184.91.513 1.237l2.707 2.707a.75.75 0 1 0 1.06-1.06l-2.707-2.707a.25.25 0 0 1-.073-.177V7a.75.75 0 0 0-.75-.75"
  }));
}
var IcClockFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcClockFill));

export { IcClockFill as I };
